import { render, staticRenderFns } from "./BaseResendOrderDetails.vue?vue&type=template&id=085245da&scoped=true"
import script from "./BaseResendOrderDetails.vue?vue&type=script&lang=js"
export * from "./BaseResendOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./BaseResendOrderDetails.vue?vue&type=style&index=0&id=085245da&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085245da",
  null
  
)

export default component.exports